(() => {
  const stabilizeButton = (btn) => {
    if (!btn) return;
    btn.style.opacity = '1';
    btn.style.filter = 'none';
  };

  const observe = (btn) => {
    if (!btn) return;
    stabilizeButton(btn);

    const obs = new MutationObserver(() => stabilizeButton(btn));
    obs.observe(btn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-busy', 'class']
    });
  };

  const init = () => {
    // Buy Now
    observe(document.querySelector('.shopify-payment-button__button'));

    // Add to Cart (Dawn)
    observe(
      document.querySelector('product-form button[name="add"].product-form__submit') ||
      document.querySelector('button.product-form__submit[name="add"]')
    );
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
